<template>
  <div class="section-container">
    <!-- Header with Add Button -->
    <b-row align-v="center" class="mb-2">
      <b-col md="12">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="text-uppercase font-weight-bold mb-0" style="display: flex; align-items: center">
            <i class="fas fa-briefcase mr-2" style="font-size: 20px !important;"></i> Experience
          </h5>
          <b-button size="sm" variant="info" @click="showAddModal">
            <i class="fas fa-plus mr-1" style="font-size: 12px !important;"></i> Add
          </b-button>
        </div>
      </b-col>
    </b-row>

    <!-- Table -->
    <b-row v-if="experiences && experiences.length > 0" align-v="center" class="mb-3">
      <b-col md="12">
        <table class="table table-striped table-bordered">
          <thead class="thead-dark text-left">
            <tr>
              <th>Sl No.</th>
              <th>Description</th>
              <th>Designation</th>
              <th>From Date</th>
              <th>To Date</th>
              <th>Nature of Employement Pay</th>
              <th>Nature of Duty</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="experience in sortedExperiences" :key="experience.id">
              <td>{{ experience.si_no }}</td>
              <td>{{ experience.description }}</td>
              <td>{{ experience.designation }}</td>
              <td>{{ formatDate(experience.from_date) }}</td>
              <td>{{ formatDate(experience.to_date) }}</td>
              <td>{{ experience.nature_of_employement_pay }}</td>
              <td>{{ experience.nature_of_duty }}</td>
              <td>
                <i class="fas fa-edit pointer text-info" style="font-size: 18px !important;"
                  @click="editExperience(experience)"></i>
                <i class="fas fa-trash fa-sm ml-2" style="cursor: pointer; color: #dc3545;"
                  @click="deleteExperience(experience)"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>

    <!-- Modal -->
    <b-modal v-model="showModal" title="Experience" @hide="resetForm" hide-footer>
      <b-form @submit.prevent="createOrUpdateExperience">
        <b-form-group label="SI No">
          <b-form-input v-model="experience.si_no" type="number"></b-form-input>
        </b-form-group>
        <b-form-group label="Description">
          <b-form-input v-model="experience.description"></b-form-input>
        </b-form-group>
        <b-form-group label="Designation">
          <b-form-input v-model="experience.designation"></b-form-input>
        </b-form-group>
        <b-form-group label="From Date">
          <b-form-input v-model="experience.from_date" type="date"></b-form-input>
        </b-form-group>
        <b-form-group label="To Date">
          <b-form-input v-model="experience.to_date" type="date"></b-form-input>
        </b-form-group>
        <b-form-group label="Nature of Employement Pay">
          <b-form-input v-model="experience.nature_of_employement_pay"></b-form-input>
        </b-form-group>
        <b-form-group label="Nature of Duty">
          <b-form-input v-model="experience.nature_of_duty"></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="primary">Save</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["profile", "profileId"],
  data() {
    return {
      showModal: false,
      editIndex: null,
      experience: {
        si_no: "",
        description: "",
        designation: "",
        from_date: "",
        to_date: "",
        nature_of_employement_pay: "",
        nature_of_duty: ""
      },
      experiences: this.profile.experiences || [],
    };
  },
  computed: {
    sortedExperiences() {
      return [...this.experiences].sort((a, b) => Number(a.si_no) - Number(b.si_no));
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },
    async createOrUpdateExperience() {
      try {
        const url = this.$store.getters.getAPIKey.mainAPI + `/userprofiles/experiences`;
        let response;

        if (this.editIndex === null) {
          // Create new
          response = await this.$axios.post(url, {
            ...this.experience,
            si_no: Number(this.experience.si_no),
            user_profile_id: this.profile.id,
          });
          this.experiences.unshift(response.data);
        } else {
          // Update existing
          const updateUrl = `${url}/${this.experience.id}`;
          response = await this.$axios.put(updateUrl, {
            ...this.experience,
            si_no: Number(this.experience.si_no),
          });
          this.experiences.splice(this.editIndex, 1, response.data);
        }

        this.$toast.success("Profile Updated", { position: "top", duration: 3000 });
        this.getProfile();
        this.showModal = false;
      } catch (error) {
        console.error("Error updating experience:", error);
        this.$toast.error("Failed to update profile", { position: "top", duration: 3000 });
      }
    },
    async getProfile() {
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/myprofile?profileId=${this.profileId}`;
        const response = await this.$axios.get(url);
        this.profile.experiences = response.data.experiences;
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    },
    showAddModal() {
      this.resetForm();
      this.showModal = true;
    },
    editExperience(experience) {
      this.experience = { ...experience };
      this.editIndex = this.experiences.findIndex(e => e.id === experience.id);
      this.showModal = true;
    },
    async deleteExperience(experience) {
      try {
        const deleteUrl = `${this.$store.getters.getAPIKey.mainAPI}/userprofiles/experiences/${experience.id}`;
        await this.$axios.delete(deleteUrl);

        const index = this.experiences.findIndex(e => e.id === experience.id);
        if (index !== -1) {
          this.experiences.splice(index, 1);
        }
        this.getProfile();
        this.$toast.success("Experience deleted", { position: "top", duration: 3000 });
      } catch (error) {
        this.$toast.error("Failed to delete experience", { position: "top", duration: 3000 });
      }
    },
    resetForm() {
      this.experience = {
        si_no: "",
        description: "",
        designation: "",
        from_date: "",
        to_date: "",
        nature_of_employement_pay: "",
        nature_of_duty: ""
      };
      this.editIndex = null;
    }
  }
};
</script>

<style scoped>
.section-container {
  padding: 14px;
  background-color: #f9f9f9;
  border-radius: 0px;
  margin-bottom: 20px;
}
</style>
